import { customElement, property } from "lit/decorators.js";
import { BaseComponent } from "../../base-component/base-component";
import { css, html } from "lit";
import { getImageSrcUrl } from "../../../common/utils/product-util";
import { WishList } from "../interfaces/wish-list-items.interface";
import "../view/wish-list-items";
import { redirectToWishListItemsURL, wishListDropdownButtons } from "../utils/wish-list.util";
import "./wish-list-dropdown-options";
import { WishListOptionsAnalytics } from "../utils/wish-list-options.analytics";

@customElement('mhecomm-wish-list-card-display')
export class WishListCardDisplay extends BaseComponent {

  static styles = css`
    .item {
      display: flex;
      align-items: center;
      margin: 1.25rem 0;
    }

    .item img {
      width: 8.313rem;
      margin-right: 1.25rem;
    }
  `;
  
  /**
  * model to load the wishlist data for the user
  */
  @property({ type: Object })
  wishList?: WishList;

  private analytics: WishListOptionsAnalytics;

  constructor() {
    super();
    this.analytics = new WishListOptionsAnalytics();
  }

  renderComp() {
    return html`
      <div class="container">
        <div class="item row border-bottom">
          <div class="col-12 col-lg-2 col-md-3 px-3 text-lg-center order-2 order-md-1">
            <img 
              aria-label="Product Card Image"
              class="product-card-img"
              src="${this.wishList?.image_url || getImageSrcUrl(this.wishList?.wishlist_items[0]?.isbn13!)}"
              alt="Product Title"
            />
          </div>
          <div class="col-12 col-lg-7 col-md-6 py-0 text-start order-3 order-md-2">
            <a 
              aria-label="${this.wishList?.name || 'Wish List Product'}"
              href="${redirectToWishListItemsURL(this.wishList?.wishlist_id)}"
              role="button"
              class="h5 d-block p-0 border-0 text-start"
              data-automation-id="wish-list-${this.wishList?.wishlist_id}"
              @click="${(e: Event) => this._navigateToWishListDetails(e)}"
            >
              ${this.wishList?.name}
            </a>
            <p 
              aria-label="${this.wishList?.wishlist_items?.length} Items"
              tabindex="0"
            >
              ${this.wishList?.wishlist_items?.length} <i>Items</i>
            </p>
          </div>
          <div class="col-12 col-lg-3 col-md-3 order-1 order-md-3 mb-md-5">
            <!-- Tablet & Mobile View -->
            <div class="d-flex d-lg-none d-md-flex justify-content-end">
              <mhecomm-wish-list-dropdown-options
                .wishList=${this.wishList}
                ?dropDownView=${true}
                .dropDownItems=${wishListDropdownButtons()}
              ></mhecomm-wish-list-dropdown-options>
            </div>
            <!-- Monitor View -->
            <div class="d-none d-lg-flex justify-content-end">
              <mhecomm-wish-list-dropdown-options
                .wishList=${this.wishList}
                .dropDownItems=${wishListDropdownButtons()}
                ?iconView=${true}
              ></mhecomm-wish-list-dropdown-options>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  _navigateToWishListDetails(event: Event) {
    event.preventDefault();
    this.analytics.wishListSelection(this, this.wishList!);
    window.location.href = (event.target as HTMLAnchorElement).href;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-wish-list-card-display': WishListCardDisplay;
  }
}